module.exports = __webpack_public_path__ + "static/media/minus.d5308b4d.svg";